export var baseVirtualCardTheme = {
  baseStyle: _ref => {
    var {
      backgroundImageSrc
    } = _ref;
    return {
      container: {
        position: 'relative',
        aspectRatio: '43 / 26',
        width: '100%',
        height: 'auto',
        maxHeight: '208px',
        maxWidth: '344px',
        borderRadius: 'xl',
        padding: 'm',
        border: 'basic.light',
        boxShadow: 500
      },
      image: {
        position: 'absolute',
        overflow: 'hidden',
        borderRadius: 'xl',
        inset: '0',
        margin: 'auto',
        width: '100%',
        height: 'auto',
        backgroundImage: backgroundImageSrc && "url(".concat(backgroundImageSrc, ")"),
        backgroundSize: 'cover'
      },
      content: {
        position: 'relative',
        zIndex: 1
      }
    };
  },
  variants: {
    white: {
      container: {
        background: 'linear-gradient(228deg, #F1F1F1 21.35%, #FFF 65.63%)'
      }
    },
    black: {
      container: {
        background: 'radial-gradient(188.74% 149.84% at 107.56% -4.33%, #666A79 0%, #313238 100%)'
      }
    },
    brand: _ref2 => {
      var {
        theme
      } = _ref2;
      var {
        main,
        darkest
      } = theme.colors['brand'];
      return {
        container: {
          background: "radial-gradient(300.07% 141.42% at 100.00% -0.00%, ".concat(main, " 0%, ").concat(darkest, " 100%)")
        }
      };
    }
  },
  defaultProps: {
    variant: 'white'
  }
};
//# sourceMappingURL=BaseVirtualCard.theme.js.map